import React from 'react';
import img from '../../Media/qrc.png'
import img2 from '../../Media/pay.png'

const Sec5 = () => {
    return (
        <div className='md:w-10/12 mx-auto grid grid-cols-12'>
            <img className='col-span-12 md:hidden w-100 mb-3' src={img} alt="" />
            <div className='col-span-12 md:col-span-6 w-11/12 md:w-full mx-auto'>
                <img className='border w-[80px] rounded-2xl' src={img2} alt="" />
                <h3 className='md:text-4xl text-3xl font-bold my-3'>LINE Pay</h3>
                <p className='text-xl font-semibold text-green-500'>Easily make</p>
                <p className='text-xl font-semibold text-green-500'>payments online/offline with LINE Pay.</p>
                <p className='text-lg font-semibold text-gray-600 mt-3'>LINE Pay is an easy, convenient, and safe payment system. Enjoy freely making payments without your wallet.</p>
                <button className='border py-3.5 rounded-md px-5 flex items-center hover:bg-green-500 hover:text-white mt-5'>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 mr-1">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
                    </svg>
                    More details
                </button>
            </div>
            <img className='col-span-12 md:col-span-6 hidden md:flex w-100' src={img} alt="" />
        </div>
    );
};

export default Sec5;